// Eltern-Portal: Adressfelder und Übernahme vom Erziehungsberechtigten.

function __asStr(x) {
  return String(x ?? "").trim();
}

function __normCountry(c) {
  const v = __asStr(c).toUpperCase();
  return v || "DE";
}

/**
 * @param {object|null|undefined} src
 */
export function pickParentPortalProfileAddress(src) {
  const p = src && typeof src === "object" ? src : {};
  return {
    street: __asStr(p.street),
    houseNumber: __asStr(p.houseNumber ?? p.house_number),
    postalCode: __asStr(p.postalCode ?? p.postal_code),
    city: __asStr(p.city),
    country: __normCountry(p.country),
  };
}

/**
 * @param {object|null|undefined} a
 * @param {object|null|undefined} b
 */
export function parentPortalProfileAddressesEqual(a, b) {
  const left = pickParentPortalProfileAddress(a);
  const right = pickParentPortalProfileAddress(b);
  return (
    left.street === right.street &&
    left.houseNumber === right.houseNumber &&
    left.postalCode === right.postalCode &&
    left.city === right.city &&
    left.country === right.country
  );
}

/**
 * @param {object|null|undefined} src
 */
export function parentPortalProfileHasAddress(src) {
  const a = pickParentPortalProfileAddress(src);
  return Boolean(a.street || a.postalCode || a.city);
}

/**
 * @param {object} form
 * @param {object|null|undefined} guardianAddress
 */
export function applyGuardianAddressToParentPortalForm(form, guardianAddress) {
  const base = form && typeof form === "object" ? { ...form } : {};
  const g = pickParentPortalProfileAddress(guardianAddress);
  return {
    ...base,
    street: g.street,
    houseNumber: g.houseNumber,
    postalCode: g.postalCode,
    city: g.city,
    country: g.country,
    addressSameAsGuardian: true,
  };
}

/**
 * @param {object|null|undefined} childFormOrProfile
 * @param {object|null|undefined} guardianAddress
 */
export function inferParentPortalAddressSameAsGuardian(childFormOrProfile, guardianAddress) {
  if (!parentPortalProfileHasAddress(guardianAddress)) return false;
  return parentPortalProfileAddressesEqual(childFormOrProfile, guardianAddress);
}
